export enum Env {
  DEV = "development",
  PROD = "production",
  STAGE = "stage",
}

export type EnvValue<T> = {
  [key in Env]: T
}

type RequestWithHeaders = { headers: { get: (key: string) => string | null } }

export const getHostName = (req?: RequestWithHeaders): string | undefined => {
  const windowLocationHost = typeof window != "undefined" ? window.location.host : undefined
  let host = (req?.headers ? req.headers.get("host") : windowLocationHost) || undefined
  if (req && req.headers.get("x-forwarded-host") && typeof req.headers.get("x-forwarded-host") === "string") {
    host = req.headers.get("x-forwarded-host")?.split(",")[0]
  }

  return host
}

export function isLocalNetwork(hostname: string): boolean {
  return (
    hostname.startsWith("localhost") ||
    hostname.startsWith("127.0.0.1") ||
    hostname.startsWith("192.168.") ||
    hostname.startsWith("10.0.") ||
    hostname.startsWith("0.0.0.0") ||
    hostname.endsWith(".local")
  )
}

export function determineEnv(req?: RequestWithHeaders): Env {
  const hostname = getHostName(req)
  if (!hostname) {
    console.warn("Couldn't determine host. Using production environment.")
    return Env.PROD
  }

  if (isLocalNetwork(hostname) || hostname.includes("dev") || hostname.includes("demo")) {
    return Env.DEV
  }

  if (hostname.includes("stage")) {
    return Env.STAGE
  }

  return Env.PROD
}

export const determineEnvV2 = (env_name: Env | string): Env => {
  switch (env_name) {
    case "development":
      return Env.DEV
    case "stage":
      return Env.STAGE
    case "production":
      return Env.PROD
    default:
      console.warn("Invalid ENV_NAME:", env_name, "Defaulting to DEV")
      return Env.DEV
  }
}
